/**
 * Only what the Offer details screen renders (`views/Offers/OfferDetail`), the
 * one offer screen a Brazilian business reaches. Brazil calls an offer a Mimo.
 * Anything missing falls back to en-US through `fallbackLocale`.
 */
export default {
  title: {
    plural: 'Mimos'
  },
  breadcrumbs: 'Mimos',
  form: {
    coinRule: {
      overviewEmpty: 'Sem limite de resgates por membro',
      overview: 'Limite de {coinLimit} {coin} por pessoa',
      noRestrictions: 'Nenhuma regra ou restrição adicional'
    },
    customerRule: {
      overviewEmpty: 'Sem limite de membros',
      overview: 'Limite de {customerLimit} {customer} para resgatar este Mimo'
    },
    otherRules: {
      noCashTransferableCanceled:
        'Sem valor em dinheiro. Intransferível. Pode ser cancelado a qualquer momento.'
    },
    expirationRule: {
      overviewEmpty: 'Sem data de expiração',
      overview: 'Este Mimo expira em {date}',
      overviewBirthday: 'Válido de 3 dias antes a 3 dias depois do aniversário'
    },
    renewedRule: {
      overview: 'Pode ser resgatado uma vez a cada{time} {period}'
    }
  },
  detail: {
    breadcrumbs: 'Detalhes do Mimo',
    tooltip: {
      opened: 'Número de vezes que os Mimos foram vistos pelos membros.',
      saved: 'Número de Mimos que foram salvos, mas ainda não resgatados.',
      redeemed: 'Número de Mimos resgatados pelos membros.',
      getDirections:
        'Número de vezes que os membros tocaram em "Como chegar" para encontrar sua loja física.',
      shared:
        'Número de vezes que os Mimos foram compartilhados pelos membros.',
      nonMemberReached:
        'Total de usuários do app Twism que ainda não são membros do seu programa e viram a sua marca enquanto navegavam pelo app.',
      offerImpressions:
        'Número total de vezes que os seus Mimos foram exibidos para membros dentro da Twism. <a target="_blank" style="text-decoration: underline;font-weight:600;" href="https://support.twism.com/hc/en-us/articles/29210709420429-What-are-Offer-Impressions">Saiba mais</a>'
    },
    combineRule: {
      empty: 'Não pode ser combinado',
      overview: 'Pode ser combinado'
    },
    redeemable: {
      both: 'Resgatável online e na loja',
      online: 'Resgatável online',
      instore: 'Resgatável na loja'
    },
    statusDisclaimer: {
      expired_offline_delete_location:
        'Este mimo expirou porque o único local disponível para resgates foi excluído.',
      expired_offline_online_delete_location:
        'Este mimo expirou porque o único local disponível para resgates na loja foi excluído.',
      active_online_delete_location:
        'O mimo anterior expirou porque o local da loja foi excluído. Este novo mimo substitui o que expirou e <strong>só pode ser resgatado online</strong>.'
    },
    share: 'Compartilhar',
    archive: 'Arquivar Mimo',
    addImage: 'Adicionar imagem',
    createdOn: 'Criado em {date}',
    dateFormat: 'DD/MM/YYYY',
    shortDateFormat: 'DD/MM/YYYY',
    status: {
      active: 'Ativo',
      expired: 'Expirado',
      archived: 'Arquivado'
    },
    sections: {
      overview: 'Visão geral',
      redeemableAt: 'Onde resgatar',
      finePrint: 'Regras do mimo',
      rules: 'Regras e restrições',
      membersRedeemed: 'Membros que resgataram'
    },
    reports: {
      opened: 'Abertos',
      saved: 'Salvos',
      getDirections: 'Rotas solicitadas',
      redeemed: 'Resgatados',
      shared: 'Compartilhados',
      nonMemberReached: 'Não membros alcançados',
      offerImpressions: 'Impressões do mimo'
    },
    redeemablePrefix: 'O mimo pode ser resgatado',
    idCardRequired: '{label}. Documento de identidade obrigatório.',
    shareText:
      '{businessName} está oferecendo {title}. Garanta o seu hoje na Twism.',
    notifications: {
      archived: 'Mimo arquivado',
      imageUpdated: 'Imagem do mimo atualizada com sucesso'
    },
    members: {
      searchPlaceholder: 'Buscar por nome',
      filterAll: 'Todos',
      filterTitle: 'Status do membro',
      filterActive: 'Ativo',
      filterInactive: 'Inativo',
      columns: {
        member: 'Membro',
        redemptionDate: 'Data do resgate',
        location: 'Local',
        status: 'Status'
      },
      lastActivity: 'Última atividade • {date}',
      redemptionDate: 'data do resgate',
      location: 'Local',
      status: {
        active: 'ativo',
        inactive: 'inativo'
      }
    }
  },
  typeTag: {
    twoForOne: 'Leve 2, pague 1',
    productAndService: 'Desconto',
    birthday: 'Mimo de aniversário',
    storewide: 'Personalizado'
  },
  archiveModal: {
    title: 'Arquivar Mimo?',
    description:
      'Ao arquivar este Mimo, os membros não vão mais vê-lo no app. <span>Esta ação não pode ser desfeita</span>.',
    confirm: 'Arquivar Mimo',
    cancel: 'Cancelar'
  },
  redeemableRule: {
    prefix: 'Resgatável',
    anyDay: 'em qualquer dia',
    weekdays: 'de segunda a sexta',
    weekends: 'nos fins de semana',
    on: '{days}',
    and: 'e',
    fromThrough: 'de {from} a {to}',
    through: 'de {from} a {to}',
    allDayLong: 'o dia todo',
    between: 'das {start} às {end}',
    days: {
      0: 'domingo',
      1: 'segunda',
      2: 'terça',
      3: 'quarta',
      4: 'quinta',
      5: 'sexta',
      6: 'sábado'
    },
    daysPlural: {
      0: 'aos domingos',
      1: 'às segundas',
      2: 'às terças',
      3: 'às quartas',
      4: 'às quintas',
      5: 'às sextas',
      6: 'aos sábados'
    }
  }
};
